export default __webpack_public_path__ + "static/media/image.55c2b6ed.jpg";